import React from 'react';
import { DatePicker, Space, Select } from 'antd';
import moment from 'moment';

const { Option } = Select;

export default function SearchFilter({ 
  onDateChange, 
  onAceptadaChange, 
  loading,
  aceptadaFilter // Añadir este prop
}) {
  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  return (
    <Space style={{ marginBottom: 16 }}>
      <DatePicker
        onChange={(date) => {
          if (date) {
            // Enviar rango de 24 horas (desde inicio del día hasta inicio del día siguiente)
            const start = date.startOf('day');
            const end = moment(date).add(1, 'day').startOf('day');
            onDateChange([start, end]);
          } else {
            onDateChange(null);
          }
        }}
        format="DD/MM/YYYY"
        placeholder="Seleccione una fecha"
        disabled={loading}
        disabledDate={disabledDate}
        allowClear
      />
      <Select
        style={{ width: 200 }}
        onChange={onAceptadaChange}
        disabled={loading}
        placeholder="Filtrar por estado"
        value={aceptadaFilter}
      >
        <Option value={false}>No Aceptadas</Option>
        <Option value={true}>Aceptadas</Option>
      </Select>
    </Space>
  );
}